"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Conjunto = void 0;
var bson_1 = require("bson");
var Conjunto = /** @class */ (function () {
    function Conjunto(_a) {
        var _b = _a._id, _id = _b === void 0 ? new bson_1.ObjectId() : _b, _c = _a.CD_MATERIAL, CD_MATERIAL = _c === void 0 ? '' : _c, _d = _a.CD_MATERIAL_COMP, CD_MATERIAL_COMP = _d === void 0 ? '' : _d, _e = _a.GRADE_CONJ, GRADE_CONJ = _e === void 0 ? '' : _e, _f = _a.GRADE_COMP, GRADE_COMP = _f === void 0 ? '' : _f, _g = _a.QUANTIDADE, QUANTIDADE = _g === void 0 ? 0 : _g, _h = _a.CHAVE_CONJ, CHAVE_CONJ = _h === void 0 ? { material: '', grade: '' } : _h, _j = _a.CHAVE_COMP, CHAVE_COMP = _j === void 0 ? { material: '', grade: '' } : _j;
        this._id = _id;
        this.CD_MATERIAL = CD_MATERIAL;
        this.CD_MATERIAL_COMP = CD_MATERIAL_COMP;
        this.GRADE_CONJ = GRADE_CONJ;
        this.GRADE_COMP = GRADE_COMP;
        this.QUANTIDADE = QUANTIDADE;
        this.CHAVE_CONJ = CHAVE_CONJ;
        this.CHAVE_COMP = CHAVE_COMP;
    }
    return Conjunto;
}());
exports.Conjunto = Conjunto;
//# sourceMappingURL=Conjunto.js.map